export default __webpack_public_path__ + "static/media/dabur.91e5a1e6.png";